export default __webpack_public_path__ + "static/media/reporting-purpose.38eca927.png";